export const isInDevelopmentEnv = process.env.REACT_APP_ENVIRONMENT === 'development';

export const isInProductionEnv =
    process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENVIRONMENT !== 'development';

export const isNodeEnvDevelopment = process.env.NODE_ENV === 'development';
